<template>
    <span class="inline-flex items-center gap-1 rounded-full px-2 py-1 text-sm font-medium"
          :class="badgeClasses">
        <span v-html="iconSvg" class="inline-flex items-center"></span>
        <span>{{ typeLabel }}</span>
    </span>
</template>

<script>
export default {
    name: 'AlarmTypeBadge',
    props: {
        type: {
            type: String,
            required: true
        }
    },
    computed: {
        badgeClasses() {
            const classes = {
                'Threshold': 'bg-purple-100 text-purple-800',
                'Offline': 'bg-gray-100 text-gray-800',
                'Validation': 'bg-blue-100 text-blue-800'
            };
            return classes[this.type] || 'bg-gray-100 text-gray-800';
        },
        iconSvg() {
            const icons = {
                'Threshold': '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12h4l3 8l4 -16l3 8h4" /></svg>',
                'Offline': '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 18l.01 0" /><path d="M9.172 15.172a4 4 0 0 1 5.656 0" /><path d="M6.343 12.343a8 8 0 0 1 3.864 -2.14m4.163 .155a8 8 0 0 1 3.287 2" /><path d="M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374" /><path d="M3 3l18 18" /></svg>',
                'Validation': '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M12 9h.01" /><path d="M11 12h1v4h1" /></svg>'
            };
            return icons[this.type] || '';
        },
        typeLabel() {
            // API returns stringType() which is already the short form
            // e.g., "Threshold", "Offline", "Validation"
            // So just return the type as-is
            return this.type;
        }
    }
};
</script>
